export const dyBehaviorList = [
  {
    label: '关注',
    value:'FOLLOWED_USER'
  },
  {
    label: '视频互动',
    value:'1',
    children: [
      {
        label: '评论',
        value: 'COMMENTED_USER'
      },
      {
        label: '点赞',
        value: 'LIKED_USER'
      },
      {
        label: '分享',
        value: 'SHARED_USER'
      },
    ]
  },
  {
    label: '直播互动',
    value:'2',
    children: [
      {
        label: '直播观看',
        value: 'LIVE_WATCH'
      },
      {
        label: '直播有效观看',
        value: 'LIVE_EFFECTIVE_WATCH'
      },
      {
        label: '直播评论',
        value: 'LIVE_COMMENT'
      },
      {
        label: '直播打赏',
        value: 'LIVE_EXCEPTIONAL'
      },
      {
        label: '直播商品点击',
        value: 'LIVE_GOODS_CLICK'
      },
      {
        label: '直播商品下单',
        value: 'LIVE_GOODS_ORDER'
      },
    ]
  },
  {
    label: '商品活动',
    value:'3',
    children: [
      {
        label: '购物车点击',
        value:'GOODS_CARTS_CLICK'
      },
      {
        label: '购物车下单',
        value:'GOODS_CARTS_ORDER'
      },
    ]
  },
]

//职业状态
export const careerTypeList = [
  { label:'大学生', key: 'COLLEGE_STUDENT' },
  { label:'教师', key: 'TEACHER' },
  { label:'IT', key: 'IT' },
  { label:'公务员', key: 'CIVIL_SERVANTS' },
  { label:'金融', key: 'FINANCIAL' },
  { label:'医务人员', key: 'MEDICAL_STAFF' },
]